import type React from 'react';

export type TooltipActionProps = React.PropsWithChildren & {
    open: boolean;
    index: number;
};

export const TooltipAction: React.FC<TooltipActionProps> = ({ children, open, index }) => {
    return (
        <div
            className={
                open
                    ? 'fade-in slide-in-from-bottom animate-in fill-mode-backwards'
                    : 'fade-out slide-out-to-bottom animate-out fill-mode-forwards'
            }
            style={{
                paddingTop: 'calc(var(--page-gap) / 2)',
                paddingBottom: 'calc(var(--page-gap) / 2)',
                animationDelay: `${index * 25}ms`,
                zIndex: `${(open ? 10 - index : index) * 10}`,
            }}
        >
            <div className='h-10 w-10 rounded-full bg-neutral-100 shadow-md child:outline-none'>{children}</div>
        </div>
    );
};
